import {Component, OnInit, Input, HostListener, Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyCheckboxChange as MatCheckboxChange} from '@angular/material/legacy-checkbox';
import {copyData} from '@app/core/model/integration-models';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {IInputField} from '@app/core/comp/dialog/input-field-dialog/input-field-dialog.component';

@Component({
    selector: 'ngc-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public injectedData: {
            useAdvancedDeleteConfirmation: boolean;
        }
    ) {
    }

    @Input() item = '';
    @Input() header = 'Are you sure?';
    @Input() target = '';
    @Input() useCheckboxList: boolean;
    @Input()
    set targetList(targetList: any[])  {
        this._targetList = targetList;
        if (this.useCheckboxList) {
            this.selectedCheckboxList = copyData(targetList);
        } else {
            this.targetListShortCopy = targetList ? targetList.slice(0, 3) : targetList;
        }
    }
    get targetList(): any[] {
        return this._targetList;
    }
    @Input() targetListItem: string;
    @Input() otherItemCancelBtnTitle = 'No';
    @Input() otherItemConfirmBtnTitle = 'Yes';
    @Input() identifierKeyName: string;
    @Input() nameKeyName: string;
    @Input() useAdvancedDeleteConfirmation = false;

    formGroup: UntypedFormGroup;
    showDescription = false;
    targetListShortCopy: string[] = [];
    selectedCheckboxList: any[] = [];

    private _targetList: any[] = null;
    readonly DELETE = 'delete';
    readonly OK = 'ok';
    readonly OTHER = 'other';
    readonly ERROR = 'error';
    readonly WELCOME_TOUR = 'welcomeTour';
    readonly TOURS_FORBIDDEN = 'toursForbidden';
    readonly TOURS_ALLOWED = 'toursAllowed';

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeydownHandler(event: KeyboardEvent) {
        if (this.useAdvancedDeleteConfirmation) {
            if (this.formGroup.valid) {
                this.onSubmit();
            }
        } else {
            this.onSubmit();
        }
        event.preventDefault();
    }
    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKeydownHandler(event: KeyboardEvent) {
        this.onCancel();
    }

    ngOnInit() {
        this.formGroup = new UntypedFormGroup({});

        if (this.useAdvancedDeleteConfirmation) {
            this.formGroup.addControl('deleteConfirm', new UntypedFormControl('', Validators.pattern(/^Delete$/)));
        }
    }

    onSubmit(result = '') {
        if (this.item === this.DELETE) {
            result = this.DELETE;
        }
        if (this.item === this.WELCOME_TOUR) {
            result = this.TOURS_ALLOWED;
        }
        if ((this.item === this.OTHER) || (this.item === this.ERROR)) {
            result = this.OK;
        }

        this.close(result);
    }

    private close(result: string) {
        if (this.useCheckboxList) {
            this.dialogRef.close(result ? this.selectedCheckboxList : null);
        } else {
            this.dialogRef.close(result);
        }
    }

    onCancel(result = '') {
        if (this.item === this.WELCOME_TOUR) {
            result = this.TOURS_FORBIDDEN;
        }
        this.close(result);
    }

    toggleCheckboxList(event: MatCheckboxChange, selectedCheckboxListItem: any): void {
        if (event.checked) {
            this.selectedCheckboxList.push(selectedCheckboxListItem);
        } else {
            const checkboxListItemIndex = this.selectedCheckboxList.findIndex((checkboxListItem: any) =>
                checkboxListItem[this.identifierKeyName] === selectedCheckboxListItem[this.identifierKeyName]
            );
            this.selectedCheckboxList.splice(checkboxListItemIndex, 1);
        }
    }
}
